<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
    width="400px"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="24">
            <el-form-item label="标签名称（英）" prop="nameEn"
                :rules="[
                  {required: true, message:'标签名称（英）不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写标签名称（英）"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="标签名称（中）" prop="nameCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写标签名称（中）"     ></el-input>
           </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
            <el-form-item label="点击次数" prop="numClicks"
                :rules="[
                 ]">
              <el-input v-model="inputForm.numClicks" placeholder="请填写点击次数"     ></el-input>
           </el-form-item>
        </el-col> -->
        <el-col :span="24">
            <el-form-item label="关联类型" prop="associationType"
                :rules="[
                  {required: true, message:'关联类型不能为空', trigger:'blur'}
                 ]">
                 <el-select
                v-model="inputForm.associationType"
                clearable
                placeholder="类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in $dictUtils.getDictList('cec_tags_type')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmTagCloudService from '@/api/cecunmtagcloud/cecUnmTagCloudService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          // numClicks: '',
          associationType: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id, currentValue) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建标签云管理`
        } else if (method === 'edit') {
          this.title = '修改标签云管理'
        } else if (method === 'view') {
          this.title = '查看标签云管理'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          this.inputForm.associationType = currentValue
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmTagCloudService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmTagCloudService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
